import React, { useEffect, useRef, useState } from 'react';
import FAQData from '../data/faq.json';
const FAQ = () => {
    const [openIndex, setOpenIndex] = useState(null);
    const panelRefs = useRef({});

    useEffect(() => {
        document.title = "FAQ - CGES.CLUB";
    }, []);

    const toggleAccordion = (index) => {
        setOpenIndex((prev) => (prev === index ? null : index));
    };

    return (
        <>
            <style>
                {`
                .ticket-accordion {
    background: #161616;
    padding: 25px 30px;
    margin-bottom: 20px;
    border-radius: 7px
}

.ticket-accordion .accordion-headers {
    padding: 0;
    line-height: 1.35;
    font-size: clamp(15px, 2.2vw, 20px);
    font-weight: 600;
    margin-bottom: 0
}

.ticket-accordion .accordion-headers .accordion-buttons {
    background-color: transparent;
    width: 100%;
    text-align: left;
    color: #fff;
    border: 0;
    padding: 0;
    position: relative;
    font-weight: 600
}

.ticket-accordion .accordion-headers .accordion-buttons .down-arrow {
    position: absolute;
    right: 0;
    top: 50%;
    -webkit-transform: translateY(-50%);
    transform: translateY(-50%);
    transition: transform .28s ease
}

.ticket-accordion .accordion-body {
    padding: 15px 0 0
}

.ticket-accordion .accordion-buttons.expanded .down-arrow {
    transform: translateY(-50%) rotate(180deg)
}

.ticket-accordion .accordion-panel {
    max-height: 0px;
    overflow: hidden;
    opacity: 0;
    transition: max-height .35s ease, opacity .25s ease
}

.ticket-accordion .accordion-panel.open {
    opacity: 1
}
    .accordion-body {
    line-height: clamp(24px, 2.8vw, 30px);
    font-size: clamp(12px, 1.8vw, 16px);
    }

    .title {
        font-size: clamp(16px, 3vw, 24px);
    }

    blockquote p {
        font-size: clamp(13px, 2.4vw, 18px);
        line-height: 1.7;
    }

    @media (max-width: 992px) {
        .ticket-accordion .accordion-headers {
            font-size: 17px;
        }

        .accordion-body {
            font-size: 14px;
            line-height: 27px;
        }

        .title {
            font-size: 20px;
        }

        blockquote p {
            font-size: 16px;
        }
    }

    @media (max-width: 576px) {
        .ticket-accordion {
            padding: 18px 16px;
        }

        .ticket-accordion .accordion-headers {
            font-size: 15px;
        }

        .accordion-body {
            font-size: 13px;
            line-height: 24px;
        }

        .title {
            font-size: 17px;
        }

        blockquote p {
            font-size: 14px;
        }
    }

                `}
            </style>


            <div className="widjet --filters">
                <div className="row">
                    <div className="col-lg-12 ps-xl-4">
                        <h3 className="uk-text-lead">FAQ's</h3>
                        <blockquote className="text-center" style={{ color: '#e4e4e4' }}>
                            <p>“Welcome to the CGES.CLUB platform! Below are answers to common questions about our platform. If you have any additional queries, feel free to reach out to our support team.”</p>
                        </blockquote>
                    </div>
                </div>
            </div>

            <div className="container">
                <div className="row">
                    <div className="col-lg-12 ps-xl-4"></div>
                    <div className="accordion-wrapper" id="accordionExample">
                        {FAQData.map((item, index) => {
                            // console.log(index);
                            if (item.type === "title") {
                                return (
                                    <div key={index}>
                                        <br /><br />
                                        <div >
                                            <h2 className='title' style={{ color: "var(--main-color-one)" }}>{item.data}</h2>
                                        </div>
                                    </div>
                                );
                            } else if (item.type === "question") {
                                const isOpen = openIndex === index;
                                const panelHeight = panelRefs.current[index]?.scrollHeight || 0;
                                return (
                                    <div key={index} className="ticket-accordion accordion-items">
                                        <h2 className="accordion-headers " id={`heading-${index}`}>
                                            <button
                                                className={`accordion-buttons d-flex justify-content-between align-items-center text-wrap w-100 ${isOpen ? "expanded" : ""}`}
                                                type="button"
                                                onClick={() => toggleAccordion(index)}
                                                aria-expanded={isOpen}
                                                aria-controls={`collapse-${index}`}
                                            >
                                                {/* {item.data.question} */}
                                                <span className="me-2">{item.data.question}</span>
                                                <i className="fa fa-angle-down down-arrow"></i>
                                            </button>
                                        </h2>
                                        <div
                                            id={`collapse-${index}`}
                                            className={`accordion-panel ${isOpen ? "open" : ""}`}
                                            aria-labelledby={`heading-${index}`}
                                            style={{ maxHeight: isOpen ? `${panelHeight}px` : "0px" }}
                                        >
                                            <div className="accordion-body" ref={(el) => { panelRefs.current[index] = el; }}>
                                                <div
                                                    dangerouslySetInnerHTML={{ __html: item.data.answer }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                )
                            }
                            else {
                                return null;
                            }
                        })}
                    </div>
                </div>
            </div>
        </>
    )
}

export default FAQ
